var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRejected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 40,
    height: 40,
    rx: 2,
    fill: "#FF5252"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9 25L20.5 21.4L24.1 25L25.5 23.6L21.9 20L25.5 16.4L24.1 15L20.5 18.6L16.9 15L15.5 16.4L19.1 20L15.5 23.6L16.9 25ZM20.5 30C19.1167 30 17.8167 29.7373 16.6 29.212C15.3833 28.6873 14.325 27.975 13.425 27.075C12.525 26.175 11.8127 25.1167 11.288 23.9C10.7627 22.6833 10.5 21.3833 10.5 20C10.5 18.6167 10.7627 17.3167 11.288 16.1C11.8127 14.8833 12.525 13.825 13.425 12.925C14.325 12.025 15.3833 11.3123 16.6 10.787C17.8167 10.2623 19.1167 10 20.5 10C21.8833 10 23.1833 10.2623 24.4 10.787C25.6167 11.3123 26.675 12.025 27.575 12.925C28.475 13.825 29.1873 14.8833 29.712 16.1C30.2373 17.3167 30.5 18.6167 30.5 20C30.5 21.3833 30.2373 22.6833 29.712 23.9C29.1873 25.1167 28.475 26.175 27.575 27.075C26.675 27.975 25.6167 28.6873 24.4 29.212C23.1833 29.7373 21.8833 30 20.5 30Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejected);
export default __webpack_public_path__ + "static/media/rejected.1e0183554e12b2bc246d1f7c3a9dc05c.svg";
export { ForwardRef as ReactComponent };